module.exports = __webpack_public_path__ + "img/products3.87780207.png";